var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar"},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-backdrop",on:{"click":_vm.closeSidebarPanel}}):_vm._e(),_c('transition',{attrs:{"name":"slide"}},[(_vm.isPanelOpen)?_c('div',{staticClass:"sidebar-panel"},[_vm._t("default")],2):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }